var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.16667V13.1668C2.5 14.1003 2.5 14.5667 2.68166 14.9232C2.84144 15.2368 3.09623 15.4921 3.40983 15.6519C3.766 15.8333 4.23249 15.8333 5.16409 15.8333H14.8359C15.7675 15.8333 16.2333 15.8333 16.5895 15.6519C16.9031 15.4921 17.1587 15.2368 17.3185 14.9232C17.5 14.5671 17.5 14.1012 17.5 13.1696V9.16667M2.5 9.16667V7.5M2.5 9.16667H17.5M2.5 7.5V6.8335C2.5 5.90008 2.5 5.43302 2.68166 5.0765C2.84144 4.76289 3.09623 4.50811 3.40983 4.34832C3.76635 4.16667 4.23341 4.16667 5.16683 4.16667H14.8335C15.7669 4.16667 16.233 4.16667 16.5895 4.34832C16.9031 4.50811 17.1587 4.76289 17.3185 5.0765C17.5 5.43267 17.5 5.89916 17.5 6.83076V7.5M2.5 7.5H17.5M5.83333 12.5H9.16667M17.5 9.16667V7.5",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBilling);
export default __webpack_public_path__ + "static/media/nav-billing.8f0af936b435a16ae93b59938f95d551.svg";
export { ForwardRef as ReactComponent };